/**
 * ---------------------------------------------------------------------------
 * Subscribes a component to the shared marketplace session store.
 *
 * @returns {{ confirmed, providerKey, signedIn, connected, status, hasOpportunity, email, companyName }}
 */

import { useEffect, useState } from 'react';
import { getSnapshot, subscribe, refresh } from './marketplaceSessionStore';

export default function useMarketplaceSession() {
	const [snapshot, setSnapshot] = useState(getSnapshot);

	useEffect(() => {
		const unsubscribe = subscribe(() => setSnapshot(getSnapshot()));
		refresh();
		
		return unsubscribe;
	}, []);

	return snapshot;
}
